import { cn } from '@repo/utils/cn';
import React, { type ReactNode, useEffect, useState } from 'react';
import { type ViewType } from '@/app/[locale]/(account)/account/withdraw';
import { type FullMethod } from '@/hooks/usePaymentMethodsWithNetworks';
import { type PaymentTypes } from '@/server-actions/payment-methods';
import PaymentMethodDetailsHeader from './payment-method-details-header';

type PaymentMethodsLayoutProps = {
  paymentType: PaymentTypes;
  view: ViewType;
  setView: (view: ViewType) => void;
  selectedMethod?: FullMethod;
  setSelectedMethod?: (method?: FullMethod) => void;
  leftSideRenderer: () => ReactNode;
  rightSideRenderer: () => ReactNode;
  isQuickDeposit?: boolean;
};

const PaymentMethodsLayout = ({
  paymentType,
  view,
  setView,
  selectedMethod,
  setSelectedMethod,
  leftSideRenderer,
  rightSideRenderer,
  isQuickDeposit,
}: PaymentMethodsLayoutProps) => {
  const [step, setStep] = useState(1);

  useEffect(() => {
    if (selectedMethod) {
      setStep(2);
    }
  }, [selectedMethod]);

  return (
    <section className="flex w-full overflow-hidden sm:space-x-4 sm:rtl:space-x-reverse">
      {/* vt-body-bg */}
      <div className={cn('w-full rounded-md sm:max-w-[270px]', step === 2 ? 'hidden sm:block' : 'block sm:block')}>
        {leftSideRenderer()}
      </div>

      <div
        className={cn(
          'h-auto w-full rounded-md p-2.5 pt-0 vt-containers-settings-box-normal-bg sm:h-auto',
          step === 1 ? 'hidden sm:block' : 'block sm:block'
        )}
      >
        <div className="flex h-full w-full flex-col rounded-md">
          <PaymentMethodDetailsHeader
            paymentType={paymentType}
            view={view}
            setView={setView}
            selectedMethod={selectedMethod}
            setSelectedMethod={setSelectedMethod}
            setStep={setStep}
            isQuickDeposit={isQuickDeposit}
          />
          {rightSideRenderer()}
        </div>
      </div>
    </section>
  );
};

export default PaymentMethodsLayout;
